var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSelectedBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21811_22965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.63345 0.808594H1.56767C0.819174 0.808594 0.212402 1.41537 0.212402 2.16386V6.22965C0.212402 6.97814 0.819174 7.58491 1.56767 7.58491H5.63345C6.38195 7.58491 6.98872 6.97814 6.98872 6.22965V2.16386C6.98872 1.41537 6.38195 0.808594 5.63345 0.808594Z",
    fill: "#212224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8566 0.808594H10.7908C10.0423 0.808594 9.43555 1.41537 9.43555 2.16386V6.22965C9.43555 6.97814 10.0423 7.58491 10.7908 7.58491H14.8566C15.6051 7.58491 16.2119 6.97814 16.2119 6.22965V2.16386C16.2119 1.41537 15.6051 0.808594 14.8566 0.808594Z",
    fill: "#212224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63345 10.0322H1.56767C0.819174 10.0322 0.212402 10.639 0.212402 11.3875V15.4533C0.212402 16.2018 0.819174 16.8085 1.56767 16.8085H5.63345C6.38195 16.8085 6.98872 16.2018 6.98872 15.4533V11.3875C6.98872 10.639 6.38195 10.0322 5.63345 10.0322Z",
    fill: "#212224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8566 10.0317H10.7908C10.0423 10.0317 9.43555 10.6385 9.43555 11.387V15.4528C9.43555 16.2013 10.0423 16.8081 10.7908 16.8081H14.8566C15.6051 16.8081 16.2119 16.2013 16.2119 15.4528V11.387C16.2119 10.6385 15.6051 10.0317 14.8566 10.0317Z",
    fill: "#212224"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21811_22965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9994,
    height: 16,
    fill: "white",
    transform: "translate(0.212402 0.808594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSelectedBudget);
export default __webpack_public_path__ + "static/media/cardSelectedBudget.b82aeafa5d7f90bf12e28f0e85d76d02.svg";
export { ForwardRef as ReactComponent };